export const SIDEBAR_TAB_DESIGN = 'Design';
export const SIDEBAR_TAB_TEXT = 'Text';
export const SIDEBAR_TAB_PREVIEW = 'Widget Preview';

export const MAIN_SIDEBAR_TABS = [SIDEBAR_TAB_DESIGN, SIDEBAR_TAB_TEXT];
